import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Toaster } from '@/components/ui/sonner';
import ApiErrorReferenceNotifier from '@/components/ApiErrorReferenceNotifier';
import '@/api/authenticatedClient';
import { installedDesktopBootstrapUnavailable } from '@/config/desktopBootstrap';

const root = ReactDOM.createRoot(document.getElementById('root'));
const desktopBootstrapUnavailable = installedDesktopBootstrapUnavailable(
  window.location.protocol,
  window.lvbDesktop,
);
if (desktopBootstrapUnavailable) {
  root.render(
    <main role="alert" style={{ maxWidth: 520, margin: '12vh auto', padding: 24, fontFamily: 'sans-serif' }}>
      <h1>Desktop services could not start</h1>
      <p>The desktop connection did not initialize. Quit and reopen LVB Workspace. If this repeats, contact an administrator.</p>
      <p>No cloud fallback was started from this screen.</p>
    </main>,
  );
} else {
  root.render(
    <React.StrictMode>
      <ApiErrorReferenceNotifier />
      <App />
      <Toaster position="top-right" />
    </React.StrictMode>,
  );
}

// Register service worker for PWA install support
if (!desktopBootstrapUnavailable && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}
